import { isClientSnapshotEnabled } from "./clientSnapshotFlag";
import { ClientSnapshotDashboardPage } from "./ClientSnapshotDashboardPage";
import { OverviewDashboardPage } from "./OverviewDashboardPage";

/** Landing page at "/" — Client Snapshot when VITE_CLIENT_SNAPSHOT_ENABLED=true, the entity-count Overview otherwise. */
export function DashboardPage() {
  return isClientSnapshotEnabled() ? <ClientSnapshotDashboardPage /> : <OverviewDashboardPage />;
}
